'use strict';

$('[data-blockclick]').on('click', function (e) {
	var $link = $(this).find('a').first();

	if ($link.length > 0) {
		var href = $link.attr('href');

		if (!$link.is(e.target)) document.location.href = href;
	}
});